import React from "react";
import { Paper, Typography, Grid, Avatar } from "@mui/material";

const ProfilePage = ({ user }) => (
  <Paper sx={{ p: 3 }}>
    <Typography variant="h4" gutterBottom>
      User Profile
    </Typography>
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <Avatar sx={{ width: 80, height: 80 }}>
          {user.displayName ? user.displayName[0] : user.email[0]}
        </Avatar>
      </Grid>
      <Grid item xs>
        <Typography variant="h6">Naam: {user.displayName || "N/A"}</Typography>
        <Typography variant="h6">Email: {user.email}</Typography>
      </Grid>
    </Grid>
  </Paper>
);

export default ProfilePage;
